import classes from "./RightSidebar.module.css";
import clsx from "clsx";
import { Button } from "components/common";
import Tabs from "./Tabs/Tabs";
import Devider2 from "components/common/Devider2/Devider";
import React, { useEffect, useRef, useState } from "react";
import { MdClose } from "react-icons/md";
import ChatSettings from "./ChatSetting";
import AppSettings from "./AppSettings";
import useOnClickOutside, { useScreenSize } from "hooks";

const RightSidebar = React.memo(
  ({ sidebar, setSidebar, selectedModel, setSelectedModel }) => {
    const [currentTab, setCurrenTab] = useState(() => {
      // Retrieve the active tab from localStorage (default to "Chat")
      const storedTab = localStorage.getItem("currentTab");
      return storedTab ? storedTab : "App";
    });

    const ref = useRef(null);

    // Handle screen resize to update `isSmallScreen`
    const isSmallScreen = useScreenSize(1280);
    useEffect(() => {
      if (isSmallScreen) {
        setSidebar(false);
      }
    }, [isSmallScreen]);
    // Call the hook conditionally based on screen size
    useOnClickOutside(ref, () => {
      if (isSmallScreen) setSidebar(false);
    });

    // Update the currentTab in localStorage whenever it changes
    useEffect(() => {
      localStorage.setItem("currentTab", currentTab);
    }, []);

    return (
      <section
        ref={ref}
        className={clsx(
          classes.sidebar,
          sidebar ? classes.showSidebar : classes.hideSidebar,
          "overflow"
        )}
      >
        <div className={classes.header}>
          <Tabs
            tabs={["App"]}
            // tabs={["Chat", "App"]}
            activeTab={currentTab}
            setActiveTab={setCurrenTab}
          />
          <button
            className={classes.sidebarButton}
            onClick={() => setSidebar((prev) => !prev)}
          >
            <MdClose />
          </button>{" "}
        </div>
        <Devider2 className={classes.devider} />
        {currentTab === "Chat" && (
          <ChatSettings
            selectedModel={selectedModel}
            setSelectedModel={setSelectedModel}
          />
        )}
        {currentTab === "App" && <AppSettings />}
      </section>
    );
  }
);
export default RightSidebar;
